
import { ContactInquiry } from '@/lib/types/contact-types';

/**
 * Map database schema to ContactInquiry frontend model
 */
export function mapDbSchemaToInquiry(dbInquiry: any): ContactInquiry {
  return {
    id: dbInquiry.id,
    name: dbInquiry.name,
    email: dbInquiry.email,
    inquiry_type: dbInquiry.inquiry_type,
    subject: dbInquiry.subject,
    message: dbInquiry.message,
    status: dbInquiry.status,
    created_at: dbInquiry.created_at,
    updated_at: dbInquiry.updated_at,
    resolved_at: dbInquiry.resolved_at
  };
}

/**
 * Map ContactInquiry frontend model to database schema
 */
export function mapInquiryToDbSchema(inquiry: Partial<ContactInquiry>) {
  return {
    id: inquiry.id,
    name: inquiry.name,
    email: inquiry.email,
    inquiry_type: inquiry.inquiry_type,
    subject: inquiry.subject,
    message: inquiry.message,
    status: inquiry.status,
    created_at: inquiry.created_at,
    updated_at: inquiry.updated_at,
    resolved_at: inquiry.resolved_at
  };
}
